import Sidebar from './Sidebar';
import enhance from './Sidebar.enhancer';

export default enhance(Sidebar);
